<template lang="pug">
.inv-popup
  .wrapper
    .title {{title}}
    .btns
      .no.btn(@click="onReject") 不接受
      .yes.btn(@click="onAccept") 接受邀请
    
  
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'InvPopup',
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['inviter', 'user']),
    title() {
      return `${this.inviter}邀请你一起体验支付宝空间站`
    },
  },
  methods: {
    ...mapMutations('app', ['setShowInvPopup']),
    onAccept() {
      this.setShowInvPopup(false)
      this.$emit('accepted')
    },
    onReject() {
      this.setShowInvPopup(false)
      this.$emit('rejected')
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.inv-popup
  position: fixed
  width: 100%
  height: 100%
  z-index: 9999
  top: 0
  left: 0
  +flex-center
  background: rgba(0, 0, 0, 0.46)
  .wrapper
    width: pxToRem(560)
    //height: pxToRem(229)
    background: white
    border-radius: pxToRem(20)
    .title
      width: 100%
      padding: pxToRem(40)
      font-size: pxToRem(36)
      color: black
      border-bottom: 1px rgba(102, 102, 102, 0.15) solid
    .btns
      width: 100%
      display: flex
      flex-direction: row
      align-items: center
      justify-content: space-between
      .btn
        width: 50%
        padding: pxToRem(25) pxToRem(40)
        font-size: pxToRem(36)
        text-align: center
        color: #1664FF
        &:first-child
          border-right: 1px rgba(102, 102, 102, 0.15) solid
        &:last-child
          font-weight: bold
</style>
